import React from "react"
import ReactEcharts from "echarts-for-react"

import { IWorkTypeInfo } from "../../../../models"
interface IProps {
    workType: IWorkTypeInfo
}

const WorkTypePieChart: React.SFC<IProps> = (props: IProps) => {    
    const workType = props.workType
    const workTypeData = workType ? [
        { name: "Core", value: Math.round(workType.Core*100), itemStyle: {color: "#4caf50"}},
        { name: "Float", value: Math.round(workType.Float*100), itemStyle: {color: "#33ab9f"} },
        { name: "Per Diem", value: Math.round(workType.PerDiem*100), itemStyle: {color: "#00b0ff"} },
        { name: "Agency", value: Math.round(workType.Agency*100), itemStyle: {color: "#f44336"} },
    ]
    : [{ name: "empty", value: 0 }] 


    const option = {
        series: [
          {
            type: 'pie',
            radius: [40, 80],
            height: '100%',
            margin: "0px auto",
            left: 'center',
            center: ["50%", "50%"],
            width: "100%",
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1,
            },
            label: {
              alignTo: 'edge',
              formatter: '{name|{b}}\n{time|{c}}%',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 15,
                  color: '#000',
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80,
            },
            labelLayout: function (params) {
              const points = params.labelLinePoints;
              if(points){
                // Update the end point.
                points[2][0] = params.labelRect.x + params.labelRect.width;
              }
              
              return {
                labelLinePoints: points,
              };
            },
            data: workTypeData,
          },
        ],
      };

    return <ReactEcharts style={{justifyContent: "center", display: "flex", height: 250}} option={option} />
}

export default WorkTypePieChart